import React, { Component } from 'react';
import { Modal, Button, Upload } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import moment from 'moment'
import md5 from 'js-md5'
import uuidv4 from 'uuid/v4'
import auth from '../../../utils/auth'
import alertMessage from '../../../utils/alertMessage';
import { inject, observer } from 'mobx-react';
@inject('uiState')
@observer
class FormImport extends Component {
  state = {
  }
  formRef = React.createRef();
  componentDidMount() {
  }

  beforeUpload = (file, FileList) => {
    return true
  }

  getHeader = () => {
    const authInfo = auth.getAuthInfo()
    const timestamp = moment().format('YYYY-MM-DD HH:mm:ss')
    const uuid = uuidv4()
    const nounce = md5(timestamp + uuid)

    return {
      timestamp,
      uuid,
      nounce,
      Authorization: `Bearer ${authInfo.token}`,
    }
  }

  onChange = (info) => {
    const { handleCancel} = this.props
    if (info.file.status !== 'uploading') {
    }
    if (info.file.status === 'done') {
      if (info.file.response.code !== 0) {
        alertMessage.error(info.file.response.messageEn)
      } else {
        handleCancel()
        alertMessage.success('Import Success！')
      }
    } else if (info.file.status === 'error') {
      alertMessage.error('Import Failed！')
    }
  }
  handleExport = () => {
    const { uiState } = this.props
    uiState.onChangeFetchingExport('/open/api/v1/apiTools/uploadDataResource/template', null, `ImportTemplate.xlsx`)
  }
  render() {
    const {modalVisible,handleCancel} = this.props
    const { Dragger } = Upload
    const UPLOAD_TEMPLATE_URL = `${window.g.apiBaseUrl}/open/api/v1/apiTools/uploadDataResource/import`

    return (
      <>
        <Modal
          title='Import'
          // closable={false}
          visible={modalVisible}
          onCancel={handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          centered
          footer={null}
        >
          <p style={{color: '#f4501c'}}>Tips：This operation will overwrite the original data！</p>
          <Dragger
            accept=".xls,.xlsx"
            action={UPLOAD_TEMPLATE_URL}
            headers={this.getHeader()}
            style={{ width: '100%', margin: '0 auto' }}
            onChange={this.onChange}
            data={{
              importDate: moment(new Date()),
            }}
            beforeUpload={this.beforeUpload}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined style={{color: 'rgb(154,219,231)'}} />
            </p>
            <p className="ant-upload-text">Click or drag the file here</p>
            <p className="ant-upload-hint" style={{ marginBottom: '10px' }}>
              Download template to fill in and upload
            </p>
          </Dragger>
          <div style={{textAlign: 'center', marginTop: 10}}>
            <Button type="primary" onClick={this.handleExport} style={{width: 180, textAlign: 'center'}}>
              Template Download
            </Button>
          </div>

        </Modal>
      </>
    );
  }
}

export default FormImport;
